import React, { useState, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

function SignIn() {
  const { setAuthTokens, triggerMenuUpdate } = useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (error) setError('');
    if (name === 'email') setEmail(value);
    if (name === 'password') setPassword(value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/auth/sign_in`, {
        email,
        password,
      });

      const accessToken = response.headers['access-token'];
      const { client, uid } = response.headers;
      const { role, id, username } = response.data.data;

      setAuthTokens({
        'access-token': accessToken,
        client,
        uid,
        userRole: role,
        userId: id,
        username,
      });

      navigate('/dashboard');

      // Forzar la actualización del menú después de 2 segundos
      setTimeout(() => {
        triggerMenuUpdate();
      }, 2000);
    } catch (error) {
      setError('Correo electrónico o contraseña incorrectos.');
      console.error('Error al iniciar sesión:', error);
    }
  };

  return (
    <div className="h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full mx-auto space-y-8 bg-white p-10 rounded-xl shadow-xl">
        <div>
          <img
            src="/images/logo2.png"
            alt="Logo de Petrotec"
            className="mx-auto h-32 w-auto mb-8"
          />
          <h2 className="mt-4 text-center text-3xl font-bold text-gray-900">
            Iniciar Sesión
          </h2>
        </div>
        <form className="space-y-5" onSubmit={handleSubmit}>
          <div className="space-y-5">
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                Correo electrónico
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                className={`
                  mt-1 block w-full px-3 py-2.5 border border-gray-300 rounded-md shadow-sm
                  placeholder-gray-400 focus:outline-none focus:ring-blue-500
                  focus:border-blue-500 text-sm transition duration-150 ease-in-out
                `}
                placeholder="ejemplo@correo.com"
                value={email}
                onChange={handleInputChange}
              />
            </div>
            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-700"
              >
                Contraseña
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className={`
                  mt-1 block w-full px-3 py-2.5 border border-gray-300 rounded-md shadow-sm
                  placeholder-gray-400 focus:outline-none focus:ring-blue-500
                  focus:border-blue-500 text-sm transition duration-150 ease-in-out
                `}
                placeholder="••••••••"
                value={password}
                onChange={handleInputChange}
              />
            </div>
          </div>

          {error && (
            <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded">
              <div className="flex">
                <div className="flex-shrink-0">
                  <svg
                    className="h-5 w-5 text-red-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293
                        1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1
                        1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <div className="ml-3">
                  <p className="text-sm text-red-700">{error}</p>
                </div>
              </div>
            </div>
          )}

          <button
            type="submit"
            className={`
              w-full flex justify-center py-2.5 px-4 border border-transparent rounded-md
              shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700
              focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
              transition duration-150 ease-in-out
              `}
          >
            Ingresar
          </button>
        </form>
      </div>
    </div>
  );
}

export default SignIn;
